export const useTopLevelData = () => {
  const config = useRuntimeConfig()
  const transform = (response) => {
    const data = response.data.map((element) => {
      return {
        id: element.id,
        ...element.attributes      
      }
    })      
    return {
      data: data,        
      meta: response.meta
    }
  }

  const getAllTopLevelDiscounts = async () => {
    const url = `/api/top-level-discounts`; 

    if (config.public.nuxtEnvironment === 'production') {
      return await useFetch(url, {
        method: 'GET',
        baseURL: config.public.nuxtAPIUrl,      
        transform: transform
      });
    }

    return await useFetch(url, {
      method: 'GET',
      transform: transform
    });
    
  }

  return {   
    getAllTopLevelDiscounts
  }
}